import {Component, OnDestroy, OnInit} from '@angular/core';
import {CacheInfoService} from "./cache_info.service";
import {Process} from "app/models/cache_info.model";
import {ConfirmComponent} from '../../views/modal/confirm.component';
import {HttpClient} from '@angular/common/http';
import {ModalService} from "app/views/modal/base_modal.component";
import {Repeater} from "../../lib/Repeater";
import {TranslateService} from "../../translate/translate.service";
import {StartCacheInfoComponent} from "./start_cache_info.component";
import dictionary from "dict/static.json";

@Component({
	selector: 'cache-info',
	templateUrl: './cache_info.component.html',
	providers: [
		CacheInfoService
	]
})
export class CacheInfoComponent implements OnInit, OnDestroy {
	
	cacheTaskList: any;
	
	public list: Process[];
	public repeater: Repeater;
	public pause: any;
	
	constructor(
		private cacheInfoService: CacheInfoService,
		private modalService: ModalService,
		private http: HttpClient,
		private _translate: TranslateService
	) {
		
	}
	
	
	async ngOnInit() {
		let me = this;
		
		me.cacheTaskList = dictionary.cacheTaskList;
		
		await me.setData();
		this.repeater = new Repeater(async function () {
			await me.setData();
		}, 2000);
		
		this.repeater.start();
	}
	
	
	async setData() {
		let data: any = await this.cacheInfoService.getList().toPromise();
		
		this.pause = data.pause;
		
		let processList = data.processList;
		
		this.list = Object.keys(processList).map(key => processList[key]);
	}
	
	
	killProcess(pid: number, main: number) {
		let me = this;
		let r = this.modalService.open(ConfirmComponent, {
			title: me._translate.instant('adminstat.support.cache_info.cache rebuild'),
			message: me._translate.instant('adminstat.support.cache_info.want kill process')
		});

		r.result.then(async function (isConfirmed: any) {
			if (me.list.length > 0 && isConfirmed === true) {
				let data = await me.cacheInfoService.killPid(pid, main).toPromise();
				if (data[1] === 1) me.list = [];
			}
		});
	}
	
	pauseRebuilding() {
		let me = this;
		let r = this.modalService.open(ConfirmComponent, {
			title: me._translate.instant('adminstat.support.cache_info.pause process'),
			message: me._translate.instant('adminstat.support.cache_info.want pause rebuild')
		});

		r.result.then(async function (isConfirmed: any) {
			if (isConfirmed) {
				await me.cacheInfoService.stopAndPauseRebuilding().toPromise();
			}
		});
	}
	
	resumeRebuilding() {
		let me = this;
		let r = this.modalService.open(ConfirmComponent, {
			title: me._translate.instant('adminstat.support.cache_info.resume process'),
			message: me._translate.instant('adminstat.support.cache_info.want resume rebuild')
		});

		r.result.then(async function (isConfirmed: any) {
			if (isConfirmed) {
				await me.cacheInfoService.resumeRebuilding().toPromise();
			}
		});
	}
	
	startRebuilding() {
		let me = this;
		
		this.modalService.open(StartCacheInfoComponent, {
			title: me._translate.instant('adminstat.support.cache_info.cache rebuild'),
			cacheTaskList: me.cacheTaskList
		}, {size: 'hg'});
	}
	
	
	// startProcess() {
	//    this.dialogService.addDialog(ConfirmComponent, {
	//     title: 'Перестроение кеша',
	//     html: '<ul><li>1</li><li>2</li></ul>'})
	//     .subscribe((isConfirmed)=>{
	//       if (isConfirmed) {
	//         console.log('kill button', pid, main);
	//
	//         this.cacheInfoService.killPid(pid, main).subscribe((data: any) => {
	//           console.log('data', data);
	//         })
	//       }
	//     });
	// }
	
	
	public openModalWithComponent() {
		//   this.bsModalRef = this.modalService.show(ModalContentComponent);
		//   this.bsModalRef.content.title = 'Запуск нового процесса перестроения';
		//   this.bsModalRef.content.list = this.cacheTaskList;
	}
	
	
	ngOnDestroy() {
		this.repeater.stop();
	}
}
